import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChangeManagementRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-change-management',
	path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
	exact: true,
};
